import { render, staticRenderFns } from "./ImportPoint.vue?vue&type=template&id=60c7fa72&scoped=true"
import script from "./ImportPoint.vue?vue&type=script&lang=js"
export * from "./ImportPoint.vue?vue&type=script&lang=js"
import style0 from "./ImportPoint.vue?vue&type=style&index=0&id=60c7fa72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7fa72",
  null
  
)

export default component.exports